import LabelsLayer from "./LabelsLayer";
import map from "./map";

export default (new LabelsLayer).addTo(map);
